export class ReportIncorrectDetails {
  reportType: string; // Person or place
  id: string;
  name: string;
  phones: string[] = [];
  fax: string;
  address: string;
  webAddress: string;
  url: string;
  captchaResponse: string;
  emailAddress: string;
}
